import React from 'react';
import "./SingleSelectQuestion.css";

const SingleSelectQuestion = ({language}) =>{
    // const [checked, setChecked] = useState(1)
    return (
        <div className = "languageQuestion">
            <p>{language}</p>
            <div className = "levelQuestion">
                <input type = "radio" name = {language} value = "ileri" checked = {true}/>
                <input type = "radio" name = {language} value = "orta"  checked = {false}/>
                <input type = "radio" name = {language} value = "temel" checked = {false}/>
                {/* Originals
                <input type = "radio" name = {language} value = "ileri" checked = {checked === 1 ? true : false} onChange = {()=> setChecked(1)}/>
                <input type = "radio" name = {language} value = "orta"  checked = {checked === 2 ? true : false} onChange = {()=> setChecked(2)}/>
                <input type = "radio" name = {language} value = "temel" checked = {checked === 3 ? true : false} onChange = {()=> setChecked(3)}/> */}
            </div> 
        </div>
    )
}

export default SingleSelectQuestion;